import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.sso.issuer,
  clientId: environment.sso.clientId,
  redirectUri: window.location.origin,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  responseType: 'code',
  timeoutFactor: 0.75,
  useSilentRefresh: true,
  scope: 'openid groups profile',
};
